export const COMPANY_INFO = {
  name: "Den Selvejende Institution Midtgaarden",
  address: "Stenbrovej 2, 6740 Bramming",
  phone: "75 17 20 80",
  phoneTel: "tel:75172080",
  email: "post@midtgaarden.dk",
  emailMailto: "mailto:post@midtgaarden.dk",
  instagram: "https://www.instagram.com/dsi_midtgaarden/",
  facebook: "https://www.facebook.com/midtgaarden",
  cvr: "26856191"
};

export const MENU_ITEMS = [
  {
    title: "Hvem er vi",
    path: "/hvem-er-vi",
    subItems: []
  },
  {
    title: "Behandling",
    path: "/behandling",
    subItems: [
      { title: "Primærbehandling", path: "/behandling/primaerbehandling" },
      { title: "Afgiftning", path: "/behandling/afgiftning" },
      { title: "Dobbeltdiagnose", path: "/dobbeltdiagnose" },
      { title: "Botilbud", path: "/botilbud" },
      { title: "Halvvejshus og udslusning", path: "/behandling/eftervaern-og-udslusning" }
    ]
  },
  {
    title: "Godkendelser og tilsyn",
    path: "/tilsyn",
    subItems: []
  },
  {
    title: "Priser",
    path: "/priser",
    subItems: []
  }
];

export const SCRAPED_PAGES = {
  index: {
    slug: "index",
    url: "https://www.midtgaarden.dk/",
    title: "Alkohol- & misbrugsbehandling i Bramming og omegn | Ring til os!",
    metaDescription: "Vi tilbyder effektiv misbrugs- og alkoholbehandling for folk med f.eks. dobbeltdiagnose. Vi har døgnbehandling i Bramming, Jylland og i hele Danmark. Ring og hør mere!",
    h1: "Misbrugsbehandling, alkoholbehandling og behandling til dobbeltdiagnosticerede",
    welcome: "Velkommen til Midtgaarden, Behandlings- og Botilbud. Misbrugsbehandling og behandling til dobbeltdiagnosticerede, samt midlertidig botilbud.",
    introText: [
      "Med mere end 20 års erfaring leverer Midtgaarden kvalificeret misbrugsbehandling til mennesker med misbrug af både stoffer og alkohol. Derudover tilbyder vi hjælp til misbrugere med dobbeltproblematikker (dobbeltdiagnose) såsom kriminalitet, ludomani og i forvejen diagnosticerede psykiatriske problemstillinger, eller tilfælde, hvor der er mistanke om psykiatriske problemstillinger. Vi hjælper folk fra hele landet med samtlige problemstillinger.",
      "Med vores brede vifte af behandlingstilbud og differentierede forløb er Midtgaarden kendt for at lave individuelt tilrettelagte behandlingsforløb og for at tilbyde en helhedsorienteret indsats, der er skræddersyet den enkelte.",
      "Hos Midtgaarden tilbyder vi professionel intelligenstestning ved psykolog gennem WAIS-IV – en internationalt anerkendt og veldokumenteret test, der måler intelligens og kognitive funktioner hos unge og voksne i alderen 18–90 år.",
      "WAIS-IV giver et billede af klientens kognitive forudsætninger og kan anvendes i mange sammenhænge, herunder:",
      "Midtgaardens døgnbehandlingstilbud henvender sig til voksne borgere fra 18 år og opefter."
    ],
    waisList: [
      "Kognitiv vurdering: En samlet vurdering af din generelle kognitive funktion og intellektuelle kapacitet.",
      "Styrker og udviklingsområder: En detaljeret profil, der tydeliggør dine kognitive styrker og svagheder – og kan skabe indsigt i eventuelle langvarige udfordringer.",
      "Uddannelses- og karrierevejledning: Et værdifuldt redskab, hvis du ønsker klarhed over, hvilke uddannelses- eller karriereveje der passer bedst til dine evner og potentialer."
    ],
    compositionHeader: "Sådan er Midtgaardens misbrugsbehandling sammensat",
    compositionText: [
      "Med en bred og fagligt velfunderet medarbejdergruppe leverer Midtgaarden behandling, som bl.a. tager afsæt i kognitiv og NLP-terapi, metoder der kombineret med CENAPS-modellen har vist sig som en bæredygtig og effektiv model til alkoholbehandling og andet misbrugsbehandling.",
      "Derudover kan vi på Midtgaarden tilbyde NADA akupunktur, mindfulness og tankefeltsterapi, samt behandling af psykiske lidelse og adfærdsmæssige forstyrrelse."
    ],
    coursesHeader: "Behandlingstilbud og forløb",
    coursesText: "I forbindelse med behandling for stof- og alkoholmisbrug tilbyder Midtgaarden følgende forløb:",
    coursesList: [
      { label: "Afgiftning", path: "/behandling/afgiftning" },
      { label: "Tilbagefaldsbehandling og tilbagefaldsforebyggelse", path: "/behandling/tilbagefaldsbehandling-og-forebyggelse" },
      { label: "Halvvejshus og dagbehandling", path: "/behandling/eftervaern-og-udslusning" },
      { label: "Dagbehandling", path: "/behandling/dagbehandling" },
      { label: "Midlertidig botilbud (§101 / §107)", path: "/paragraf-101-og-paragraf-141" }
    ],
    calloutText: "Vi tilbyder også forløb i forhold til dobbeltdiagnose og står for din rådgivning, behandling og afgiftning."
  },

  hvemErVi: {
    slug: "hvem-er-vi",
    title: "Hvem er vi? | Behandlingscenter i Bramming nær Esbjerg | Læs om os",
    metaDescription: "Hvem er vi? - Den Selvejende Institution Midtgaarden",
    h1: "Hvem er vi?",
    intro: "Her på siden kan du blive klogere på, hvem der er at finde på Midtgaarden.",
    leadership: [
      {
        title: "Institutionsleder",
        name: "Palle Jensen",
        email: "palle@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-palle-jensen.jpg",
        details: [
          "Ansat siden december 2002",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "2 årig NLP Masterterapeut",
          "CENAPS uddannet (PSGT, DMC, MAPT, RPC, RPT)",
          "MBRP Instruktør (Mindfulness-based Relapse Prevention)",
          "Dobbeltdiagnose uddannet med speciale i ACT og hjernens Neuropsykologiske opbygning - speciale i kognitiv adfærdsterapi ved dobbeltdiagnoser.",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "Postrologisk akupunktur",
          "Tankefelt terapi uddannelse"
        ]
      },
      {
        title: "Souschef",
        name: "Carina Kruse",
        email: "carina@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-carina-kruse.jpg",
        details: [
          "Ansat siden februar 2015",
          "Uddannet Socialrådgiver 2015",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "CENAPS (PSGT)",
          "Moduluddannelse i Systemisk og Narrativ terapi",
          "MBRP Instruktør (Mindfulness-based Relapse Prevention)",
          "Grundkursus i Tankefelts terapi/EFT",
          "Moduluddannelse i Standard Dialektisk Adfærds Terapi (DAT)"
        ]
      }
    ],
    advisors: [
      {
        name: "Pia Larsen",
        email: "pia@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-pia-larsen.jpg",
        details: [
          "Ansat siden juli 2004",
          "Uddannet social- og sundhedshjælper",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "Injektionskursus",
          "2 årig NLP Masterterapeut",
          "CENAPS (ATP, PSGT, RPC, RPT)",
          "Kognitiv terapeutisk misbrugsuddannelse",
          "Dobbeltdiagnose uddannet med speciale i ACT og hjernens Neuropsykologiske opbygning - speciale i kognitiv adfærdsterapi ved dobbeltdiagnoser.",
          "MBRP Instruktør (Mindfulness-based Relapse Prevention)",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "Grundkursus i Tankefelts terapi/EFT",
          "Master Practitioner i Proptreptik",
          "Moduluddannelse i Standard Dialektisk Adfærds Terapi (DAT)"
        ]
      },
      {
        name: "Pernille Fich-Fabricius",
        email: "pernille@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-pernille-fich-fabricius.jpg",
        details: [
          "Ansat siden oktober 2020",
          "Uddannet Socialrådgiver 2019",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "SMART- Recovery facilitator.",
          "Dobbeltdiagnose uddannelsen med speciale i ACT og Behandling af kognitive vanskeligheder ved mennesker med dobbeltdiagnose i et neuropsykologisk perspektiv"
        ]
      },
      {
        name: "Mathilde Hedegaard",
        email: "mathilde@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-matilde-toerring.jpg",
        details: [
          "Ansat siden april 2021",
          "Uddannet socialrådgiver 2021",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "1. år som Practitioner inden for NLP",
          "Master Practitioner i Proptreptik"
        ]
      },
      {
        name: "Manuela Sendzikowski",
        email: "manuela@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-manuela-hansen.jpg",
        details: [
          "Ansat siden august 2021",
          "Uddannet Socialrådgiver 2007",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "3 årig uddannelse i Narrativ terapi",
          "Kognitiv grunduddannelse",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "MBRP Instruktør (Mindfulness-based Relapse Prevention)",
          "Moduluddannelse i Standard Dialektisk Adfærds Terapi (DAT)",
          "Uddannet praktikvejleder",
          "Manuela har tidligere arbejdet som myndighed med Børn og Familie, og Voksen myndighed"
        ]
      },
      {
        name: "Chris Holland",
        email: "chris@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-chris-nielsen.jpg",
        details: [
          "Ansat siden december 2022",
          "Uddannet Socialpædagog 2025",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "Moduluddannelse i Standard Dialektisk Adfærds Terapi (DAT)"
        ]
      }
    ],
    healthStaff: [
      {
        title: "Psykiater",
        name: "Julius Nissen",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-julius-nissen.jpg",
        details: [
          "Psykiater, 40 års psykiatrisk erfaring",
          "Misbrug, 20 års erfaring",
          "Har konsultation med de af Midtgaardens beboere, der har brug for psykiatrisk støtte"
        ]
      },
      {
        title: "Sygeplejerske",
        name: "Lone Brøndum",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-lone-kristensen.jpg",
        details: [
          "Psykiatrisk sygeplejerske",
          "Uddannet førstehjælpsinstruktør",
          "Diplomuddannet i pædagogik",
          "Master i misbrug"
        ]
      },
      {
        title: "Psykolog",
        name: "Max Buntzen Müller",
        email: "mbm@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/medarbejder-pladsholder.jpg",
        details: [
          "Ansat siden december 2024",
          "Uddannet cand. psyk. 2023",
          "Gestaltterapeutisk metode og intervention",
          "Teoretisk og praktisk anvendelse af Acceptance and Commitment Therapy",
          "Praktisk udførelse af psykodynamisk terapi."
        ]
      }
    ],
    nightStaff: [
      {
        name: "Mikkel Toftegaard",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-mikkel-lassen.jpg",
        details: [
          "Ansat siden august 2022",
          "Uddannet pædagogisk assistent",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "Moduluddannelse i Standard Dialektisk Adfærds Terapi (DAT)"
        ]
      },
      {
        name: "Jesper Olesen",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/medarbejder-pladsholder.jpg",
        details: [
          "Ansat siden januar 2025",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)"
        ]
      }
    ],
    otherStaff: [
      {
        role: "Køkken",
        name: "Mathias Hult",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/medarbejder-pladsholder.jpg",
        details: ["Ansat siden marts 2024"]
      },
      {
        role: "Pedel",
        name: "Sigurd Andersen",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-sigurt-kristensen.jpg",
        details: [
          "Ansat siden januar 2003",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "Uddannet mekaniker",
          "CENAPS (PSGT)",
          "Sigurd er Midtgaardens altmuligmand, og kan fikse ALT"
        ]
      },
      {
        role: "Bogholder",
        name: "Elisabeth Jensen",
        email: "bogholder@midtgaarden.dk",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/medarbejder-pladsholder.jpg",
        details: [
          "Ansat siden februar 2025",
          "Ansvarlig for regnskab, og primær kontakt med revisor/revision",
          "Økonomi uddannet"
        ]
      },
      {
        role: "IT medarbejder",
        name: "Cliff Hulsten",
        image: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/portraet-cliff-madsen.jpg",
        details: [
          "Ansat siden december 2018",
          "Medicinhåndtering",
          "Udvidet førstehjælp",
          "NADA (Øreakupunktur til afhjælpning af abstinenser)",
          "Uddannet Multimedie designer",
          "PBA i Webudvikling",
          "Uddannet kok",
          "Cliff er IT-nørden på Midtgaarden"
        ]
      }
    ]
  },

  midtgaarden: {
    slug: "midtgaarden",
    title: "Behandlingscenter i Bramming | Misbrug og dobbeltdiagnostiserede",
    metaDescription: "Midtgården blev stiftet i 1995 og er nu en selvejende institution. Personkredsen er udvidet til også at omfatte misbrugere med psykiske og/eller psykiske problematikker.",
    h1: "Midtgaarden",
    intro: "Den selvejende institution Midtgaarden er bestående af to afdelinger; Midtgaarden, der er beliggende i den lille by Sejstrup lidt udenfor Bramming samt halvvejshuset, der ligger i Esbjerg.",
    sections: [
      {
        h2: "Selvejende institution siden 2002",
        paragraphs: [
          "Midtgaarden har eksisteret som behandlingssted siden 1995 og overgik i 2002 fra at være privatejet til at være en selvejende institution, der drives som en socialøkonomisk virksomhed. Vi er en bredt fagligt sammensat personalegruppe, alle med mange års erfaring i arbejdet med mennesker i en udsat position.",
          "Midtgaarden ligger lidt udenfor Bramming i Esbjerg Kommune, hvor vi har til huse i en nedlagt landejendom, der løbende er renoveret og moderniseret. Vi har plads til 18 beboere på Midtgaarden, og derudover har vi plads til 8 beboere i vores halvvejshus i Esbjerg, hvorfra der er mulighed for udslusning."
        ]
      },
      {
        h2: "Sådan foregår behandlingen",
        paragraphs: [
          "På Midtgaarden arbejder vi ud fra en bio-psyko-social forståelsesramme og behandlingen er helhedsorienteret med fokus på det enkelte menneskes aktuelle situation samt behov for behandling, støtte og vejledning.",
          "Vores tilbud er baseret på CENAPS modellen, og vi arbejder ud fra en positivistisk og anerkendende tilgang, og møder det enkelte menneske med ligeværd, respekt og med opmærksomhed på personlig integritet.",
          "Med en bred og fagligt velfunderet medarbejdergruppe, leverer Midtgaarden behandling som bl.a. tager afsæt i kognitiv og NLP terapi, metoder der kombineret med CENAPS modellen har vist sig som en bæredygtig og effektiv model til alkoholbehandling og andet misbrugsbehandling.",
          "Derudover kan vi på Midtgaarden tilbyde NADA akupunktur, mindfulness og tankefeltsterapi."
        ]
      },
      {
        h2: "Tilknyttede fagpersoner",
        paragraphs: [
          "Vi har fast tilknyttet psykiater, psykolog og sygeplejerske. Derudover arbejder vi tæt sammen med det lokale lægehus i Bramming samt Lokalpsykiatrien i Esbjerg.",
          "Hvis der er brug for det, tilbyder vi på Midtgaarden at lave en foreløbig psykiatrisk vurdering. Såfremt det vurderes nødvendigt, samarbejder vi med eksterne psykiatere, der vil kunne forestå en psykiatrisk udredning i forbindelse med f.eks. alkoholbehandling."
        ]
      },
      {
        h2: "Godkendelser",
        paragraphs: [
          "Midtgaarden er underlagt Lov om Socialtilsyn og er godkendt til at drive behandlingssted i.h.t. Lov om Social Service § 101, jf. § 107 samt Sundhedsloven § 141. Tilsynet forestås af Socialtilsyn Syd.",
          "Derudover er Midtgaarden godkendt af Justitsministeriet som alternativt afsoningssted i henhold til Straffuldbyrdelseslovens § 78."
        ]
      }
    ]
  },

  tilsyn: {
    slug: "tilsyn",
    title: "Tilsyn for Midtgaarden i Bramming | Behandlingscenter for misbrugere",
    metaDescription: "Tilsyn for Midtgaarden i Bramming | Behandlingscenter for misbrugere",
    h1: "Godkendelser og tilsyn",
    intro: "På denne side findes links til de forskellige rapporter som er udført af forskellige samarbejdspartnere. Disse er alle med til at sikre at Midtgaarden lever op til kravene for god misbrugsbehandling.",
    documents: [
      {
        title: "Socialtilsyn Syd - Afrapportering",
        issuer: "Socialtilsyn Syd",
        date: "07.09.2026",
        docType: "PDF",
        fileUrl: "/_assets/afrapportering-07-09-2026-socialtilsyn-syd.pdf",
        linkText: "Link til seneste rapport (Godkendt)",
        category: "Socialtilsyn"
      },
      {
        title: "Styrelsen for Patientsikkerhed - Tilsynsrapport",
        issuer: "Styrelsen for Patientsikkerhed",
        date: "16.08.2022",
        docType: "PDF",
        fileUrl: "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/65-tilsynsrapport-16-08-2022-patientsikkerhedsstyrelsen.pdf",
        linkText: "Link til seneste tilsynsrapport",
        category: "Styrelsen for Patientsikkerhed"
      },
      {
        title: "Fødevarestyrelsen - Kontrolrapport (Smiley)",
        issuer: "Fødevarestyrelsen",
        date: "02.03.2022",
        docType: "Eksternt link",
        fileUrl: "https://www.findsmiley.dk/73513",
        linkText: "Link til seneste rapport (Smiley)",
        category: "Fødevarestyrelsen"
      }
    ],
    qualityScores: [
      { title: "Uddannelse og beskæftigelse", score: "5.0", icon: "fa-graduation-cap", color: "#3885B8", description: "Beboernes udvikling i uddannelse og beskæftigelsesrettede tilbud" },
      { title: "Selvstændighed og relationer", score: "5.0", icon: "fa-handshake-angle", color: "#10B981", description: "Støtte til selvstændiggørelse og sociale relationer" },
      { title: "Målgruppe, metoder og resultater", score: "5.0", icon: "fa-bullseye", color: "#8B5CF6", description: "Faglige metoder tilpasset målgruppens behov" },
      { title: "Sundhed og trivsel", score: "5.0", icon: "fa-heart-pulse", color: "#EC4899", description: "Fysisk og psykisk sundhed samt samlet trivsel" },
      { title: "Organisation og ledelse", score: "4.8", icon: "fa-sitemap", color: "#F59E0B", description: "Strategisk ledelse og velfungerende organisation" },
      { title: "Kompetencer", score: "5.0", icon: "fa-user-check", color: "#06B6D4", description: "Personalets faglige og pædagogiske kompetencer" },
      { title: "Fysiske rammer", score: "5.0", icon: "fa-house-chimney", color: "#3B82F6", description: "Trygge, rummelige og velholdte faciliteter" },
      { title: "Økonomi", score: "5.0", icon: "fa-chart-pie", color: "#14B8A6", description: "Bæredygtig og gennemskuelig økonomisk drift" }
    ]
  },

  priser: {
    slug: "priser",
    title: "Priser på behandling i Midtgaarden | Afgiftning, primærbehandling og dagbehandling",
    metaDescription: "Priser på behandling i Midtgaarden | Afgiftning, primærbehandling og dagbehandling",
    h1: "Priser",
    subHeader: "Priser på Midtgaarden pr. d. 01.01.2026",
    priceItems: [
      {
        title: "Døgnbehandling på Midtgaarden, herunder afgiftning og primærbehandling",
        price: "Kr. 62.675,50,-/md.",
        details: "(Prisen inkluderer kost og logi, al behandling samt al afgiftningsmedicin)",
        note: "Ved svært alkoholmisbrug, kan der i særlige tilfælde være behov for at indkalde ekstra personale, til at raide under afrusning. Her pålægges ekstra beregning i nattetimerne. Ring for yderligere uddybning."
      },
      {
        title: "Midtgaardens halvvejshus med dagbehandling (Udslusning)",
        price: "Kr. 31.337,75,-/md.",
        details: "(Prisen inkluderer kost og logi og al behandling)"
      },
      {
        title: "Dagbehandling 4 dage",
        price: "Kr. 20.420,-/md.",
        details: "(Prisen inkluderer frokost og al behandling)"
      },
      {
        title: "Midlertidig botilbud § 107 Sejstrup",
        price: "62.675,50,-/md.",
        details: "(Prisen inkluderer frokost og al behandling)"
      },
      {
        title: "Midlertidig botilbud § 107 Esbjerg",
        price: "31.337,75,-/md.",
        details: "(Prisen inkluderer frokost og al behandling)"
      },
      {
        title: "§85 Støttetimer",
        price: "550,-/timen",
        details: "(Ved et særlig krav til indholdet at timerne, kan der ske yderligere fakturering)"
      },
      {
        title: "WAIS-IV test",
        price: "Attestation: 3.000 kr. / Rapport: 6.000 kr.",
        details: "Attestation: Kort skriftlig tilbagemelding – 3.000 kr. | Uddybende rapport: Grundig skriftlig rapport med detaljeret gennemgang af resultater – 6.000 kr. (Selve testen tager ca. 2 timer)"
      },
      {
        title: "Psykiatrisk vurdering og medicin",
        price: "Inkluderet i behandlingsprisen",
        details: "(Alm. psykiatriske samtaler, vurdering og afgiftningsmedicin er medregnet i behandlingsprisen) Andre former for faste ordinationer, afholdes af beboeren selv."
      }
    ]
  },

  sejstrup: {
    slug: "midtgaarden-i-sejstrup",
    title: "Boforhold på Midtagaarden i Bramming | Fællesrum, boafdelinger og fritidsområder",
    metaDescription: "Boforhold på Midtagaarden i Bramming | Fællesrum, boafdelinger og fritidsområder",
    h1: "Midtgaarden i Sejstrup",
    intro: "Midtgaarden i Sejstrup har til huse i en ældre trelænget landejendom, der løbende er blevet renoveret og moderniseret. Huset er delt i 3 forskellige bo-afdelinger og har flere fællesrum, hvor der er mulighed for at se TV eller lave forskellige aktiviteter. Til ejendommen hører derudover et større udenoms areal med bl.a. Beachvolley bane, Petanquebane, mulighed for at spille basket og lave bål.",
    commonRooms: [
      "2 TV-stuer",
      "Stor \"kaffestue\"",
      "Pool rum",
      "Bordtennis rum",
      "Flere rum med mulighed for kreativt arbejde",
      "Fælles vaskeri",
      "Spisesal"
    ],
    livingSections: [
      "”Huset nede” - består af 5 værelser, 2 toiletter og fælles stue",
      "”Huset oppe” - består af 3 værelser, 1 toilet og fælles stue",
      "”Lejlighedsgangen” – består af 4 lejligheder med stue og toilet med bad nede og 2 separate soveværelser på første sal",
      "Derudover 2 værelser, hvor der deles bad og toilet samt fællesstue"
    ],
    highlightNote: "I alle bo-afdelinger er der trådløs internet og køleskab!",
    address: "Stenbrovej 2, 6740 Bramming",
    images: [
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/hvidmalet-bygning-med-graesplaene-og-hegn.jpg",
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/traeterrasse-med-liggestole-foran-traehytte.jpg",
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/madlavning-ved-stort-komfur-i-industrikoekken.jpg"
    ]
  },

  esbjerg: {
    slug: "halvvejshuset-i-esbjerg",
    title: "Behandlingscenter ved Esbjerg | Misbrug og dobbeltdiagnostiserede",
    metaDescription: "Halvvejshuset i Esbjerg | Behandlingscenter for misbrugere",
    h1: "Halvvejshuset i Esbjerg",
    intro: "Halvvejshuset i Esbjerg fungerer som udslusning for beboere, der er i slutningen af deres forløb og på vej videre ud i livet. Huset er en villa beliggende på en stille villavej i det centrale Esbjerg.",
    facilities: [
      "Fælles køkken i forbindelse med stue/alrum",
      "Stor entre med trappe til 1. sal",
      "Bryggers med fælles vaskemaskine og tørretumbler",
      "8 værelser",
      "2 toiletter med bad"
    ],
    outdoorText: "Til villaen hører garage, skur og en stor lukket have med terrasse ligesom der er trådløst internet i huset.",
    address: "Grundtvigs Alle 64A, 6700 Esbjerg",
    images: [
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/faellesskab-og-samtale-omkring-kaffebord.jpg",
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/individuel-samtale-i-laenestol-under-ovenlysvindue.jpg",
      "https://assets.auxodev.dk/assets/caa9ce5a-9b51-4c31-bd1f-3a73d776d9c2/kroketkoeller-i-trae-havespil.jpg"
    ]
  },

  paragraf: {
    slug: "paragraf-101-og-paragraf-141",
    title: "Paragraf 101 og Paragraf 141 hos Midtgaarden i Bramming | Ring til os!",
    metaDescription: "Få specialiseret støtte til en meningsfuld hverdag ved Servicelovens Paragraf 101 og 141. Midtgaardens team hjælper med handlingsplaner og udvikling. Ring i dag!",
    h1: "Paragraffer der kan anbringes efter på Midtgaarden",
    subH1: "SEL § 101 jf. 107, § 101, § 107 og SUL § 141",
    intro: "I vores arbejde på Midtgaarden er det afgørende at forstå og overholde de relevante lovgivningsmæssige rammer. To centrale paragraffer fra servicelovgivningen i denne sammenhæng er paragraf 101 (jf. §107) og paragraf 141, som direkte påvirker vores arbejde og de ydelser, vi tilbyder.",
    sections: [
      {
        h2: "SEL §101 - Grundlaget for vores arbejde",
        paragraphs: [
          "Paragraf 101 jf. 107 i den danske servicelov er fundamentale for vores arbejde med misbrugsbehandling. Paragraf 101 fastlægger rammerne for tilbud om særlig støtte til voksne, herunder personer med misbrugsproblemer. Denne paragraf sikrer, at voksne, som grundet særlige sociale problemer ikke selv kan varetage deres interesser eller ikke kan indgå i nødvendigt samarbejde med det offentlige, har ret til hjælp.",
          "I forlængelse heraf præciserer §107, at kommunerne skal tilbyde ophold i boformer som Midtgaarden for voksne med betydelige sociale problemer, hvilket inkluderer misbrug. Denne paragraf er central, da den sikrer retten til og rammerne for vores arbejde med at tilbyde et trygt og støttende miljø, hvor beboerne kan arbejde på deres recovery."
        ]
      },
      {
        h2: "SEL §107 - Midlertidig botilbud",
        paragraphs: [
          "I særlige tilfælde er der behov for yderligere støtte efter et endt døgnbehandlingsforløb, men med et særligt øje for at skulle leve en stoffri tilværelse. Her tilbyder Midtgaarden midlertidig ophold efter servicelovens § 107, midlertidig botilbud, med relevant misbrugsbehandling og særligt fokus på ADL træning og mulighed for at opstarte i en beskæftigelsesrette indsats.",
          "Opholde kan både bevilliges på Midtgaarden i Sejstrup, og i Midtgaardens halvvejshus i Esbjerg. Dog med forskellige vilkår de forskellige steder. Kontakt os gerne, for yderligere."
        ]
      },
      {
        h2: "SUL §141 – Særligt om alkoholmisbrug",
        paragraphs: [
          "Hos os forstår vi vigtigheden af støtte til dem, der kæmper med alkoholmisbrug. Vi er godkendt til behandling i henhold til sundhedslovens Paragraf 141, som sikre, at alle har adgang til vederlagsfri behandling.",
          "Vi samarbejder bredt med kommunale institutioner, regionale sundhedsfaciliteter og private udbydere for at tilbyde dig den bedste hjælp muligt. Alt dette sker med støtte fra det lokale socialtilsyn, som godkender og fører tilsyn med vores behandlingssteder, alt sammen baseret på de nyeste og mest effektive metoder.",
          "Vores mål er at støtte dig gennem din rejse mod et sundere liv."
        ]
      },
      {
        h2: "Forpligtelse over for lovgivningen",
        paragraphs: [
          "I Midtgaarden tager vi vores ansvar alvorligt, når det gælder om at overholde disse paragraffer. Det er vigtigt for os at arbejde inden for de fastsatte lovgivningsmæssige rammer, ikke kun for at overholde loven, men også for at sikre den bedst mulige støtte og behandling til vores beboere.",
          "Vores engagement i at overholde disse paragraffer afspejler vores dedikation til at levere en service, der er både sikker, effektiv og respektfuld over for den enkelte beboers behov og rettigheder.",
          "Du finder vores institution i Sejstrup tæt ved Esbjerg, hvor vi tager mod beboere fra hele Jylland og resten af Danmark."
        ]
      }
    ]
  },

  regler: {
    slug: "regler",
    title: "Regler på Midtgaarden | Behandlingscenter for misbrugere",
    metaDescription: "Regler på Midtgaarden | Behandlingscenter for misbrugere",
    h1: "Regler på Midtgaarden",
    mainRules: "Vi har 2 regler vi håndhæver mere end noget andet, nemlig at der ikke må forekomme vold eller stoffer på Midtgården.",
    rulesList: [
      "Din mobiltelefon ikke må virke forstyrrende på dagsprogrammet, derfor må du kun bruge den udenfor eller på dit værelse.",
      "Du skal deltage aktivt i behandlingsprogrammet.",
      "Du må ikke forlade Midtgårdens område uden tilladelse.",
      "De elektriske komponenter du vælger at have på dit værelse må ikke spille så højt at det virker forstyrrende for andre beboere.",
      "Du må have egen bærbar computer med, men den skal følge de regler der for brug på Midtgaarden."
    ],
    insuranceNote: "Du bør være opmærksom på, at de effekter du vælger at tage med dig på dit værelse på Midtgården ikke er omfattet af Midtgårdens indboforsikring. Du opfordres derfor til selv at tegne en indboforsikring såfremt du ikke allerede har en sådan.",
    relationshipsNote: "Det hænder at beboere bliver forelskede i hinanden. Skulle dette ske, bør du være opmærksom på, at forhold på Midtgården først accepteres når begge parter har mindst 30 dages stoffrihed. Såfremt dette ikke respekteres betragtes det som brud på husets regler. Etablerede par kan overnatte sammen 3 gange ugentligt.",
    tripsNote: "Midtgårdens regler omkring ture ud af huset under behandlingen er, at der til enhver til skal ansøges skriftligt om dette til personalet. For at der kan gives lov skal man vurderes til at være i et godt forløb, dette gælder både terapeutisk, i forhold til omgangen i huset, og så skal man have orden i sine daglige gøremål. Hvis disse kriterier er opfyldt kan man komme ud af huset. Dog tidligst jævnfør nedenstående.",
    tripMilestones: [
      "30 dages Stoffrihed: Tur til Esbjerg (4 timer), med følge af en anden beboerer der er berettiget til dette",
      "40 dages Stoffrihed: Hjemmeweekend"
    ]
  },

  praktiskeOplysninger: {
    slug: "praktiske-oplysninger",
    title: "Praktiske oplysninger - Den Selvejende Institution Midtgaarden",
    metaDescription: "Praktiske oplysninger om ophold, regler, boforhold og kontakt på Midtgaarden i Bramming.",
    h1: "Praktiske oplysninger",
    intro: "Her finder du en oversigt over praktiske oplysninger vedrørende ophold og hverdag på Midtgaarden."
  }
};

export const COMMON_CONTACT_CALLOUT = {
  header: "Kontakt os og hør mere om muligheden for døgnbehandling",
  p1: "Har du brug for at få hjælp til at komme ud af misbrug, eller er du i kontakt med en, som har det? Så er du meget velkommen til at ringe hertil på telefon 75 17 20 80 og høre mere om døgnbehandling og Midtgaarden generelt.",
  p2: "Du kan også sende en e-mail til os på post@midtgaarden.dk, hvis du vil høre mere om alkoholbehandling, behandling af dobbeltdiagnose eller noget helt andet.",
  p3: "Du kan læse mere om vores behandlingstilbud, metoder, personale m.v. her på hjemmesiden, og du er selvfølgelig altid velkommen til at kontakte os, hvis du har spørgsmål til os."
};
